import BRAND_LIST from "database/sell-gift-cards-brands.json";

export const getBrandSellData = (urlSlug) =>
  BRAND_LIST.filter(({ slug }) => slug === urlSlug)?.[0];
